// extracted by mini-css-extract-plugin
export default {"root":"deltaHelperText_root__oABzs"};